import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar", "overlay"];

  connect() {
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown.bind(this));
  }

  open(event) {
    event.preventDefault();
    this.sidebarTarget.classList.add('open');
    this.overlayTarget.classList.add('active');
    document.body.style.overflow = 'hidden';

    if (this.toggleButton) {
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    const firstMenuItem = this.sidebarTarget.querySelector('.sidebar-menu__button');
    if (firstMenuItem) {
      firstMenuItem.focus();
    }
  }

  close(event) {
    if (event) event.preventDefault();
    this.sidebarTarget.classList.remove('open');
    this.overlayTarget.classList.remove('active');
    document.body.style.overflow = '';

    if (this.toggleButton) {
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.sidebarTarget.classList.contains('open')) {
      this.close();
    }
  }

  get toggleButton() {
    return this.element.querySelector('.menu-toggle');
  }
}
